import { render, staticRenderFns } from "./PayGuide.vue?vue&type=template&id=5d7a8cfb&scoped=true"
import script from "./PayGuide.vue?vue&type=script&lang=js"
export * from "./PayGuide.vue?vue&type=script&lang=js"
import style0 from "./PayGuide.vue?vue&type=style&index=0&id=5d7a8cfb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7a8cfb",
  null
  
)

export default component.exports